export const DND_FLIP_DURATION_MS = 200;
export const MIN_COUNT = 1;
export const MAX_AREA_COUNT = 9;
export const MAX_CATEGORY_COUNT = 9;
export const MAX_THING_COUNT = 99;
